import { render, staticRenderFns } from "./ChooseHall.vue?vue&type=template&id=e2ffe282&scoped=true"
import script from "./ChooseHall.vue?vue&type=script&lang=js"
export * from "./ChooseHall.vue?vue&type=script&lang=js"
import style0 from "./ChooseHall.vue?vue&type=style&index=0&id=e2ffe282&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ffe282",
  null
  
)

export default component.exports